import { TAnonymousSplitTest, TBranch } from './useAnonymousSplitTests';

export function runSplitTest(
  splitTest: TAnonymousSplitTest,
  randomNumber: number,
): TBranch {
  const { branches, defaultBranch } = splitTest;

  const roundedNumber = Math.round(randomNumber);

  if (roundedNumber === 1) {
    return branches[0];
  }

  return {
    branchName: defaultBranch,
    testPercentage: 0.5,
  };
}
